import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty, type FirestorePromotion } from '../firestore/Promotion'
import { PromotionType } from '../firestore/Promotion/types'
import { computed } from 'mobx'

export class Promotion extends ObservableModelWithDecorators<FirestorePromotion> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePromotion>
  ) {
    super(repository, doc)
  }

  @computed
  get promotionType() {
    const validPromotionTypes = Object.values(PromotionType)

    if (validPromotionTypes.includes(this.id as PromotionType))
      return this.id as PromotionType

    return 'unknown'
  }
}
